import { AppBundle } from '@/utils/app-bundles';
import { RedirectRegexToTargetApp, v1HydraJourneysRegex } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function JourneysRedirectRoute() {
  return <RedirectRegexToTargetApp regex={v1HydraJourneysRegex} targetApp={AppBundle.Journeys} />;
}

export const Route = createFileRoute('/journeys/$')({
  component: JourneysRedirectRoute,
});
